
/**
 * Sprint Task
 * https://developerx.atlassian.net/browse/CS-5132
 *
 * Date Created : 13 Dec 2021       Created by   : Risman Abdilah
 * Date Updated : 14 Dec 2021       Updated by   : Risman Abdilah
 *
 * Version 1.0.1
 */

import Vue from "vue";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";
import { Watch } from "vue-property-decorator";

import { CoachmarkModel } from "@/models/coachmark.model";
import { JobFairEventModel, JobFairPartnerModel } from "@/models/job.model";

import JobsFairActive from "./JobsFairActive.vue";
import JobsFairList from "./JobsFairList.vue";
import JobFairCandidateList from "@/components/jobfair/JobFairCandidateList.vue";
import JobFairCompanyList from "@/components/jobfair/JobFairCompanyList.vue";
import JobFairEventList from "@/components/jobfair/JobFairEventList.vue";
import ModalAddEvent from "@/components/jobfair/event/ModalAddEvent.vue";
import ModalEditEvent from "@/components/jobfair/event/ModalEditEvent.vue";
import ModalDeleteEvent from "@/components/jobfair/event/ModalDeleteEvent.vue";
import JobFairPartnerList from "@/components/jobfair/JobFairPartnerList.vue";
import ModalAddPartner from "@/components/jobfair/partner/ModalAddPartner.vue";
import ModalDeletePartner from "@/components/jobfair/partner/ModalDeletePartner.vue";
import ModalJobFairInfo from "@/components/jobfair/ModalJobFairInfo.vue";
import ModalConfirmTAC from "@/components/jobfair/ModalConfirmTAC.vue";
import { AxiosResponse } from "axios";
import toast from "@/functions/toast.function";

@Component({
  components: {
    JobsFairActive,
    JobsFairList,
    JobFairCandidateList,
    JobFairCompanyList,
    JobFairEventList,
    ModalAddEvent,
    ModalEditEvent,
    ModalDeleteEvent,
    JobFairPartnerList,
    ModalAddPartner,
    ModalDeletePartner,
    ModalJobFairInfo,
    "modal-confirm-tac": ModalConfirmTAC,
  },
})
export default class JobsFairMain extends Vue {
  /* VUEX */

  // ACTION
  @Action("actionGetLastJobFair", { namespace: "job" })
  public actionGetLastJobFair: any;
  @Action("actionJobFairDetail", { namespace: "job" })
  public actionJobFairDetail: any;
  @Action("actionJobFairCompanyList", { namespace: "job" })
  public actionJobFairCompanyList: any;
  @Action("actionJobFairCandidateList", { namespace: "job" })
  public actionJobFairCandidateList: any;
  @Action("actionJobFairHistoryList", { namespace: "job" })
  public actionJobFairHistoryList: any;
  @Action("actionGetEventJobfair", { namespace: "job" })
  public actionGetEventJobfair: any;
  @Action("actionDetailEventJobfair", { namespace: "job" })
  public actionDetailEventJobfair: any;
  @Action("actionEditEventJobfair", { namespace: "job" })
  public actionEditEventJobfair: any;
  @Action("actionDeleteEventJobfair", { namespace: "job" })
  public actionDeleteEventJobfair: any;
  @Action("actionGetPartnerJobfair", { namespace: "job" })
  public actionGetPartnerJobfair: any;
  @Action("actionDeletePartnerJobfair", { namespace: "job" })
  public actionDeletePartnerJobfair: any;

  // STATE
  @State("job_fair", { namespace: "job" })
  public job_fair: any;
  @State("job_fair_event", { namespace: "job" })
  public job_fair_event: JobFairEventModel;
  @State("array_job_fair_event", { namespace: "job" })
  public array_job_fair_event: Array<JobFairEventModel>;
  @State("coachmark_data", { namespace: "coachmark" })
  public coachmark_data: CoachmarkModel;

  @Watch("activeTab")
  public onActiveTabChanged(val: any, oldVal: any) {
    if (val === 1) {
      this.period_start = "";
      this.period_end = "";
      this.filterJobFairHistory();
    }
  }

  @Watch("bottomTab")
  public onChangeBottomTab(val: any, oldVal: any) {
    if (val === 1) {
      this.filter_jobfair.company = "";
      if (this.job_fair.id) {
        this.actionJobFairCompanyList({
          params: null,
          success: (responseCompanyList: any) => {
            // TODO
          },
          fail: (responseCompanyList: any) => {
            // TODO
          },
        });
      }
    } else {
      this.filter_jobfair.candidate = "";
      if (this.job_fair.id) {
        this.actionJobFairCandidateList({
          params: null,
          success: (responseCandidateList: any) => {
            // TODO
          },
          fail: (responseCandidateList: any) => {
            // TODO
          },
        });
      }
    }
  }

  @Watch("showModalAddEvent")
  public onShowAddEventChanged(val: any) {
    if (val) {
      this.actionDetailEventJobfair({ params: null });
    }
  }

  /* INITIALIZATION */

  public activeTab: number = 0;
  public bottomTab: number = 0;
  public hideList: boolean = false;
  public showModalInfoJobfair: boolean = false;
  public showModalAddEvent: boolean = false;
  public showModalEditEvent: boolean = false;
  public showModalDeleteEvent: boolean = false;
  public showModalAddPartner: boolean = false;
  public showModalDeletePartner: boolean = false;
  public selectedPartnerDelete: JobFairPartnerModel =
    new JobFairPartnerModel();
  public tabs = [
    {
      text: "active",
      href: "#",
    },
    {
      text: "inactive",
      href: "#",
    },
  ];
  public period_start: string = "";
  public period_end: string = "";
  public filter_jobfair = {
    candidate: "",
    company: "",
  };
  public showModalTAC = false;
  // BUG => https://developerx.atlassian.net/browse/CS-5513
  // Fixed on 30 Mar 2022.
  // Fixed by Risman Abdilah.
  public showCoachMarkJobsFair = false;

  constructor() {
    super();
  }

  public created() {
    this.getTab();
    this.resetFilter();
    this.actionGetLastJobFair({
      params: null,
      success: (responseActive: any) => {
        // TODO
        this.getDetailJobFair();
        this.actionGetEventJobfair();
        this.actionGetPartnerJobfair();
      },
      fail: (responseActive: any) => {
        // TODO
      },
    });
  }

  /* METHODS */
  public onEditEvent(event: JobFairEventModel) {
    this.actionDetailEventJobfair({
      params: event,
      success: () => {
        this.showModalEditEvent = true;
      },
    });
  }

  public onShowDeleteEvent(event: JobFairEventModel) {
    this.actionDetailEventJobfair({
      params: event,
      success: () => {
        this.showModalDeleteEvent = true;
      },
    });
  }

  public onDeleteEventConfirm() {
    this.actionDeleteEventJobfair({
      params: this.job_fair_event.id,
      success: () => {
        this.actionGetEventJobfair();
        this.actionDetailEventJobfair({ params: null });
      },
    });
  }

  public onDeletePartner(partner: JobFairPartnerModel) {
    this.selectedPartnerDelete = partner;
    this.showModalDeletePartner = true;
  }

  public onDeletePartnerConfirm() {
    this.actionDeletePartnerJobfair({
      params: this.selectedPartnerDelete.id,
      success: () => {
        this.actionGetPartnerJobfair();
      },
    });
  }

  public getDetailJobFair() {
    this.actionJobFairDetail({
      params: {
        id: this.job_fair.id,
      },
      success: (response: any) => {
        // TODO
        this.actionJobFairCompanyList({
          params: null,
          success: (responseCompanyList: any) => {
            // TODO
          },
          fail: (responseCompanyList: any) => {
            // TODO
          },
        });
        this.actionJobFairCandidateList({
          params: null,
          success: (responseCandidateList: any) => {
            // TODO
          },
          fail: (responseCandidateList: any) => {
            // TODO
          },
        });
      },
      fail: (response: any) => {
        // TODO
      },
    });
  }

  public filterJobFairHistory() {
    this.actionJobFairHistoryList({
      params: {
        period_start: this.period_start,
        period_end: this.period_end,
      },
      success: (response: any) => {
        (this.$refs.FilterJobFairHistory as any).hide();
      },
      fail: (response: any) => { },
    });
  }

  public filterJobFairCandidate() {
    if (this.job_fair.id) {
      this.actionJobFairCandidateList({
        params: this.filter_jobfair.candidate.toLowerCase(),
        success: (responseCandidateList: any) => {
          this.filter_jobfair.candidate = "";
          (this.$refs.JobFairSearch as any).hide();
        },
        fail: (responseCandidateList: any) => {
          // TODO
        },
      });
    } else toast.warning(this.$t('warning_empty_jobfair_add_event'));
  }

  public filterJobFairCompany() {
    if (this.job_fair.id) {
      this.actionJobFairCompanyList({
        params: this.filter_jobfair.company.toLowerCase(),
        success: (responseCompanyList: any) => {
          this.filter_jobfair.company = "";
          (this.$refs.JobFairSearch as any).hide();
        },
        fail: (responseCompanyList: any) => {
          // TODO
        },
      });
    } else toast.warning(this.$t('warning_empty_jobfair_add_event'));
  }

  public resetFilter() {
    this.period_start = "";
    this.period_end = "";
    this.filterJobFairHistory();
  }

  public getTab() {
    const tabJobFair = localStorage.getItem("TabJobFair");
    const tabJobFairBottom = localStorage.getItem("TabJobFairBottom");

    if (this.$route.params.from === "endjobfair") {
      this.activeTab = 1;
    } else if (tabJobFair) {
      this.activeTab = parseInt(tabJobFair);
    } else {
      this.activeTab = 0;
    }

    if (tabJobFairBottom) {
      this.bottomTab = parseInt(tabJobFairBottom);
    } else {
      this.bottomTab = 0;
    }
  }

  public setTab(isBottomTab: boolean = false) {
    if (isBottomTab) {
      if (this.bottomTab === 0) {
        localStorage.setItem("TabJobFairBottom", "1");
      } else {
        localStorage.setItem("TabJobFairBottom", "0");
      }
    } else {
      if (this.activeTab === 0) {
        this.hideList = true;
        localStorage.setItem("TabJobFair", "1");
      } else {
        this.hideList = false;
        localStorage.setItem("TabJobFair", "0");
      }
    }
  }

  public onCreateJobFair() {
    this.showModalTAC = true;
  }

  public onAcceptTACJobfair() {
    this.showModalTAC = false;
    this.$router.push({ name: "createJobFair" });
  }

  public OnClickAddEvent() {
    if (this.job_fair.id) this.showModalAddEvent = true;
    else toast.warning(this.$t('warning_empty_jobfair_add_event'));
  }

  /**
   * OnClickAddPartner
   */
  public OnClickAddPartner() {
    if (this.job_fair.id) this.showModalAddPartner = true;
    else toast.warning(this.$t('warning_empty_jobfair_add_event'));
  }
}
